import { defineStore } from 'pinia'

import type { TasksKanbanStore } from './interfaces'

import { TaskPriority } from '@ts-tasks-kanban/enums'

import { actions } from './actions'
import { getters } from './getters'

export const useTasksKanbanStore = defineStore('tasks-kanban', {
  state: (): TasksKanbanStore => ({
    tasks: null,
    agents: [],
    customer: null,
    relatedTo: null,
    taskType: null,
    team: null,
    stage: null,
    priority: TaskPriority.NoPriority,
    deadline: null,
    createdAt: null,
    updatedAt: null,
    assignee: null,
    creator: null,
    waitingReason: null,
    resolution: null,
    customerOutcome: null,
    cancelReason: null,
    submitted: false,
    comment: null,
    extraFieldsByTaskType: {},
    logs: [],
    logsPagination: {
      per_page: 25,
      next_cursor: null,
      next_page_url: null,
      prev_cursor: null,
      prev_page_url: null,
    },
  }),
  actions,
  getters,
})
